export default {
  HAS_DEPOSIT: "Charges a deposit",
  DEPOSIT_AMOUNT: "Deposit amount",
  BUYING_DEPOSIT_AMOUNT: "Deposit paid to supplier",
  PRODUCTS_LIST: "Product List",
  ADD_PRODUCT: "Add Product",
  PRODUCT_ADDED: "Product Added",
  EDIT_PRODUCT: "Edit Product",
  PRODUCT_UPDATED: "Product Updated",
  DELETE_THIS_PRODUCT: "Delete this product?",
  PRODUCT_DELETED: "Product Deleted",
  BARCODE: "Barcode",
  POS_DEPARTMENT_CODE: "POS department (code)",
  WITH_DEPOSIT: "With a deposit",
  WITHOUT_DEPOSIT: "Without a deposit",
  POS_DEPARTMENT_NAME: "POS department (name)",
  SYNC_PRODUCT: "Synchronize products",
  RUN_SYNCHRONIZE_PRODUCTS: "Run synchronization",
  SELECT_REPLACEMENTS: "Select replacements",
  REPLACEMENTS: "Replacements",
  GO_TO_REPLACEMENT_LINE: "Go to replacement line",
  REPLACEMENT_CODE_COPIED: "Replacement product code copied to clipboard",
  REPLACEMENT_LINE_NOT_FOUND:
    "We couldn't find that replacement in the current list. Clear filters and try again.",
  DELETED_PRODUCT_REPLACEMENT_REQUIRED:
    "Deleted products must have replacement items. Please select one or more products.",
  REPLACEMENTS_UPDATED: "Replacements updated",
  ONLY_WITHOUT_REPLACEMENTS: "Only products without replacements",
  DELETED_PRODUCT_REPLACEMENTS_MESSAGE:
    "This product has been deleted. Please use one of the replacement products listed below.",
  DELETED_PRODUCT_QUANTITY_BLOCKED:
    "Quantity changes are disabled for deleted products. Please select a replacement product.",
  NO_REPLACEMENTS_AVAILABLE: "No replacement products available.",
  SPECIAL_ORDER: "Special order",
  SPECIAL_ORDER_HELPER:
    "This line comes from a supplier-only special order product and always defaults to zero quantity.",
  CAN_HAVE_HALF_UNIT: "Product available in half-case",
  CAN_HAVE_HALF_UNIT_HELPER: "This product can be ordered in half-cases",
  HALF_UNIT_SURCHARGE: "Half-case surcharge",
  BACKORDER_NOTE: "Backorder note",
  BACKORDER_NOTE_HELPER:
    "Optional note shown anywhere this product is marked as backorder.",
  SELLABLE_PRODUCTS: "Sellable products",
  BUYABLE_PRODUCTS: "Buyable products",
  RESET_TO_DEFAULT_PRICE: "Reset to default price",
};
